import Sparkline from './Sparkline';

export default Sparkline;
